import { useEffect, useState } from "react";
import getUbicaciones from "../services/Ubicaciones/getUbicaciones";
import { useSelector, useDispatch } from "react-redux";
import { addList } from "../../redux/reducers/Ubicaciones/ubicacionesSlice";

export default function useGetUbicaciones() {
  const [loading, setLoading] = useState(true);
  const emisor = useSelector((state) => state.ubicaciones.value);
  const dispatch = useDispatch();

  useEffect(() => {
    if (emisor.length === 0) {
      getUbicaciones().then((result) => {
        setLoading(false);
        const datosTabla = [];
        let data2 = [];
        data2 = result.payload;
        data2.forEach((x) => {
          if (x.ambito === "S") {
            x.ambito = "SGI";
            Object.assign(x, { ambitoInicial: "S" });
          } else if (x.ambito === "A") {
            x.ambito = "SGI + TRD";
            Object.assign(x, { ambitoInicial: "A" });
          } else {
            x.ambito = "TRD";
            Object.assign(x, { ambitoInicial: "T" });
          }

          datosTabla.push(x);
        });

        dispatch(addList(datosTabla));
      });
    } else {
      setLoading(false);
    }
  }, [emisor]);

  return { loading };
}
